import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 25.5 25.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.5 25.5\" id=\"check\">\n    <path stroke=\"#000000\" stroke-linecap=\"round\" fill=\"none\" d=\"m5.994 12.908 3.207 3.371 7.961-8.37\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol